import { useContext } from 'react';
import SidebarContext, {
  SidebarContextProps,
} from './../context/SidebarContext';

const useSidebar = (): SidebarContextProps => useContext(SidebarContext);

export default useSidebar;
